import styled from "@emotion/styled";
import Slider from "@mui/material/Slider";
import { useTranslation } from "react-i18next";
import { Breakpoints, mq } from "src/helpers/mediaQuery";

import { useSliderValue } from "../../../hooks/useSliderValue";
import { Counter } from "../../Default/LekUI/Counter";

function CountOfQuestionsProgress(props) {
	const { t } = useTranslation();
	const { value, setValue, maxCount } = useSliderValue({
		value: props.value,
		setDetails: props.setDetails,
		length: props.maxQuestions,
		max: 200,
	});

	return (
		<div className={props.className}>
			<div>
				<p>{t("filters.exams.additional.countOfQuestions")}</p>
				<Counter count={value} unit={t("units.questions")} />
			</div>
			<Slider
				defaultValue={value}
				max={maxCount}
				min={10}
				value={value}
				onChange={(_e, value) => setValue(value)}
				step={10}
				data-test-id="question-count-slider"
			/>
			<p>{t("filters.exams.additional.hint")}</p>
		</div>
	);
}

export default styled(CountOfQuestionsProgress)`
  padding-left: 8px;

  > div:first-of-type {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;

    & > p {
      margin: 0 0 0 -8px;
      font-size: 12px;
      color: #aaa5b1;
    }
  }

  > p {
    margin: 0 0 0 -8px;
    font-size: 12px;
    color: #aaa5b1;
  }

  ${mq(Breakpoints.sm)} {
    padding: 0 20px 0 12px;

    > div:first-of-type {
      & > p {
        margin: 0 0 0 -12px;
      }
    }
  }
`;
